module.exports = __webpack_public_path__ + "img/interactions.63bc7d44.svg";